import { render, staticRenderFns } from "./deviceDetailTip.vue?vue&type=template&id=589da35f&scoped=true&"
import script from "./deviceDetailTip.vue?vue&type=script&lang=js&"
export * from "./deviceDetailTip.vue?vue&type=script&lang=js&"
import style0 from "./deviceDetailTip.vue?vue&type=style&index=0&id=589da35f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589da35f",
  null
  
)

export default component.exports